export default {
  ARCHIVED: 'Archyvuotas',
  NEW_PASSWORD: 'Įveskite naują slaptažodį',
  REPEAT_NEW_PASSWORD: 'Pakartokite naują slaptažodį',
  PASSWORD_IS_REQUIRED: 'Slaptažodis yra privalomas',
  PASSWORDS_MUST_MATCH: 'Slaptažodžiai turi sutapti',
  PASSWORD_CHANGED_SUCCESSFULLY: 'Slaptažodis sėkmingai pakeistas',
  INFORMATION: 'Informacija',
  SERVICE: 'Paslauga',
  STATUS: 'Būsena',
  EXTEND_TIME: 'Pratęsti laiką',
  TIME_EXTENDED: 'Laikas pratęstas!',
  NEW_CLIENTS_ONLY: 'Tik naujiems klientams',
  ONE_TIME_DISCOUNT: 'Vienkartinė nuolaida',
  PAYMENT_METHOD_REQUIRED: 'Reikalingas mokėjimo būdas',
  GENERATE_ONE_TIME_PROMO_CODES: 'Vienkartiniai promo kodai',
  ICON_FOR_APP: 'Programėlės piktograma',
  SELECT_CAMPAIGN: 'Pasirinkite kampaniją',
  WHICH_WILL_BE_VALID_FOR: 'Kuri galios',
  AFTER: 'Po',
  DAYS: 'dienų',
  ACTIVATE: 'Aktyvuoti',
  CREATE_NEW_CAMPAIGN: 'Sukurti naują kampaniją',
  ACTIVATE_NEW_CAMPAIGN: 'Aktyvuoti naują kampaniją',
  PROMO_CODES: 'Promo kodai',
  CREATE_NEW_PROMO_CODES: 'Sukurti naujus promo kodus',
  AMOUNT_OF_NEW_CODES: 'Naujų kodų skaičius',
  DETAILS: 'Detalės',
  COPY: 'Kopijuoti',
  RESET_PASSWORD: 'Atstatyti slaptažodį',
  COPY_PASSWORD_RESET_LINK: 'Kopijuoti atstatymo nuorodą',
  LOGIN_AS_THIS_USER: 'Prisijungti kaip šis naudotojas',
  ACTIVE_SESSION: 'Aktyvi sesija',
  ACTIVE_SESSIONS: 'Aktyvios sesijos',
  VERIFIED: 'Patvirtinta',
  LOCATIONS: 'Vietos',
  ZONES: 'Zonos',
  PLEASE_BE_PATIENT: 'Prašome palaukti...',
  SELECT_ZONE: 'Pasirinkite zoną',
  SELECT_PLACE: 'Pasirinkite vietą',
  FILTERS: 'Paieška',
  ADD_NEW_USER: 'Pridėti naują naudotoją',
  ADD_USER_SLASH_COMPANY: 'Pridėti naudotoją / įmonę',
  EDIT_USER_SLASH_COMPANY: 'Redaguoti naudotoją / įmonę',
  ACCESS_TO_PLATFORM: 'Prieiga įjungta',
  CAN_VEW_PARKING_FINES: 'Gali peržiūrėti parkavimo baudas',
  ENFORCEMENT_APP_ENABLED: 'Kontrolės programėlė įjungta',
  IS_NEW_TENANT: 'Sukurti leidimų sąrašą nuomininkui',
  NAME_IS_REQUIRED: 'Vardas yra privalomas',
  EMAIL_IS_REQUIRED: 'El. paštas yra privalomas',
  IN_PLACES: 'Vieta',
  IN_ZONES: 'Zona',
  EXPIRED: 'Pasibaigęs',
  ACTIVE: 'Aktyvus',
  ACTIVE_PLURAL: 'Aktyvus',
  DOWNLOAD_TEMPLATE_FILE: 'Atsisiųsti šablono failą',
  HOME: 'Pagrindinis',
  TITLE: 'Pavadinimas',
  MESSAGE: 'Žinutė',
  SESSION: 'Sesija',
  COST_IN_EUROS: 'Kaina eurais',
  INVOICES: 'Sąskaitos faktūros',
  noDataText: 'Nėra duomenų rodymui',
  YES: 'Taip',
  NO: 'Ne',
  CANCEL: 'Atšaukti',
  CAN_NOT_BE_UNDONE: 'To negalima anuliuoti',
  SEARCH_BY_NAME: 'Ieškoti pagal pavadinimą...',
  PREVIEW: 'Peržiūra',
  ARE_YOU_SURE: 'Ar esate tikri?',
  COUNTRY_CODE: 'Šalies kodas',
  LOADING_NEW_CONTENT: 'Įkeliamas naujas turinys...',
  NEW_CONTENT_AVAILABLE: 'Yra naujo turinio. Prašome',
  REFRESH: 'Atnaujinti',
  YEAR: 'Metai',
  MONTH: 'Mėnuo',
  EDIT: 'Redaguoti',
  ADD: 'Pridėti',
  DELETE: 'Ištrinti',
  SAVE: 'Išsaugoti',
  LOG_OUT: 'Atsijungti',
  LOG_IN: 'Prisijungti',
  BACK: 'Atgal',
  CLOSE: 'Uždaryti',
  LIST_EMPTY: 'Sąrašas tuščias',
  PREVIOUS: 'Ankstesnis',
  NEXT: 'Kitas',
  PAGE: 'Puslapis',
  SHOW: 'Rodyti',
  MONDAY: 'Pirmadienis',
  TUESDAY: 'Antradienis',
  WEDNESDAY: 'Trečiadienis',
  THURSDAY: 'Ketvirtadienis',
  FRIDAY: 'Penktadienis',
  SATURDAY: 'Šeštadienis',
  SUNDAY: 'Sekmadienis',
  CURRENCY: 'Valiuta',
  TOTAL: 'Iš viso',
  COUNT: 'Kiekis',
  VALID_FROM: 'Galioja nuo',
  VALID_TO: 'Galioja iki',
  DESCRIPTION: 'Aprašymas',
  IMPORT_FROM_FILE: 'Importuoti iš failo',
  INVITE_FROM_FILE: 'Pakviesti iš failo',
  SEARCH: 'Paieška',
  EXPORT_TO_EXCEL: 'Eksportuoti į Excel',
  COMMENTS: 'Komentarai / informacija',
  CLIENT_ID: 'Kliento ID',
  PHONE_NUMBER: 'Telefono numeris',
  CAR_NUMBER: 'Valstybinis numeris',
  CLIENT_ACTIVE_CAR_NUMBER: 'Aktyvus kliento valstybinis numeris',
  EMAIL: 'El. paštas',
  NAME: 'Vardas',
  LOCATION: 'Vieta',
  START_TIME: 'Pradžios laikas',
  END_TIME: 'Pabaigos laikas',
  INVALID_DATE: 'Netinkama data',
  INVALID_TIME: 'Netinkamas laikas',
  COST: 'Kaina',
  TYPE: 'Tipas',
  REGION: 'Regionas',
  ZONE: 'Zona',
  OPERATOR: 'Operatorius',
  GENERATE: 'Generuoti',
  SEND_TO_EMAIL: 'Siųsti el. paštu',
  EMAIL_REQ_INFO: 'Gauta registracijos užklausa žinutė',
  EMAIL_REG_REQ_INFO:
    'El. pašto informacija, jei „Automatinis patvirtinimas“ išjungtas',
  CODE: 'Kodas',
  ERROR_GLOBAL: 'Kažkas nepavyko! Bandykite dar kartą vėliau.',
  COMMENTS_FOR_ENFORCEMENT: 'Komentarai kontrolei',
  PARKING_ACTIVE: 'Parkavimas aktyvus',
  PARKING_NOT_ACTIVE: 'Parkavimas neaktyvus',
  WITH_BOOKING: 'Su rezervacija',
  WITHOUT_BOOKING: 'Be rezervacijos',
  PARKING_SESSIONS_OVER_FREE_TIME: 'Parkavimo sesijos viršijus nemokamą laiką',
  EXTRA_FILTER: 'Papildomas filtras',
  HEADER: {
    LANGUAGE: 'Kalba'
  },
  EMPTY_STATE: {
    WHITELIST_EMPTY_HERE: 'Čia tuščia',
    WHITELIST_EMPTY_HERE_MESSAGE: 'Jūs neturite jokio leidžiamų sąrašo',
    FLEETS_EMPTY_HERE: 'Čia tuščia',
    FLEETS_EMPTY_HERE_MESSAGE: 'Jūs neturite jokių transporto parkų',
    USERS_EMPTY_HERE: 'Čia tuščia',
    USERS_EMPTY_HERE_MESSAGE:
      'Jūs neturite naudotojų arba neturite teisių redaguoti naudotojus',
    WHITELISTS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Pateikta transporto priemonė nepriklauso jokiam leidimų sąrašui',
    FLEETS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Pateikta transporto priemonė nepriklauso jokiam transporto parkui'
  },
  ALLOWED_TO_CALL: {
    TITLE: 'Leidimų sąrašas',
    PHONE_NUMBER: 'Telefonas',
    CAR_NUMBER: 'Automobilis',
    NAME: 'Vardas',
    APP: 'Pridėti į programėlę',
    VALID_UNTIL: 'Galioja iki',
    INVALID_INPUTS: 'Reikalingas telefono numeris ir automobilio numeris',
    CALLS: 'Žurnalas',
    CHARGE_FOR_SESSIONS: 'Mokestis už sesijas'
  },
  DASHBOARD: {
    TITLE: 'Valdymo skydelis',
    DESCRIPTION: 'Visos leidimų sąrašų ir transporto parkų aktyvios sesijos',
    PLACES_TITLE: 'Jūsų vietos',
    PLACES_DESCRIPTION: 'Visos vietos, kurias galite valdyti',
    ADDRESS: 'Adresas',
    THIS_MONTH_REVENUE: 'Šio mėnesio pajamos',
    LAST_MONTH_REVENUE: 'Praėjusio mėnesio pajamos',
    CHANGE_ALLOWED_TO_CALL: 'Leidimų sąrašas',
    SESSIONS_TITLE: 'Sesijos',
    SESSIONS_DESCRIPTION: 'Visos sesijos jūsų valdomose vietose',
    GENERAL_FILTERS: 'Filtrai',
    CAR_NUMBER: 'Automobilio numeris',
    RESERVATION_TIME: 'Rezervacijos laikas',
    START_TIME: 'Pradžios laikas',
    END_TIME: 'Pabaigos laikas',
    STATUS: 'Būsena',
    COST: 'Kaina',
    CLIENT: 'Klientas',
    CLIENTS_PHONE: 'Kliento telefonas',
    CLIENTS_NAME: 'Kliento vardas',
    PLACE: 'Vieta',
    PAYMENT_INFO: 'Mokėjimo informacija',
    PAID_WITH_MONTHLY_PASS: 'Apmokėta mėnesiniu abonementu',
    PAID_WITH_CREDITCARD: 'Apmokėta kreditine kortele',
    WHITELISTED: 'Įtrauktas į leidimų sąrašą',
    PLACE_NAME: 'Vieta',
    SEARCH: 'Paieška',
    UTILIZATION: 'Užimtumas',
    PAYMENT_FROM: 'Nuo',
    PAYMENT_TO: 'Iki',
    SUMMARY: 'Santrauka',
    REVENUE: 'Pajamos',
    MONTHLY_PASSES_REVENUE: 'Mėnesiniai abonementai',
    OWNERS_SHARE: 'Savininko dalis',
    PHONE_CALL: 'Skambutis',
    RFID: 'RFID',
    INVOICE: 'Sąskaita faktūra',
    PAYMENT_LOGS: 'Mokėjimų žurnalai',
    CREDIT: 'Kreditas',
    WHITELISTS: 'Leidimų sąrašai',
    FLEETS: 'Transporto parkai',
    CAMPAIGNS: 'Kampanijos',
    CAMPAIGN_CODE: 'Kampanijos kodas',
    REG_LIMIT: 'Registracijos limitas',
    REGISTRANTS: 'Registruotojai',
    NO_ACTIVE_CAMPAIGNS: 'Nėra aktyvių kampanijų',
    PAYOUTS: 'Išmokos',
    USERS: 'Naudotojai',
    USERS_DESCRIPTION: 'Visi naudotojai, kuriuos galite valdyti',
    CAMPAIGN_DESCRIPTION: 'Visos kampanijos',
    START_SESSION: 'Pradėti parkavimą',
    REPORTS: 'Ataskaitos',
    TYPES: 'Tipas:',
    REGIONS: 'Regionas:',
    ZONES: 'Zona:',
    OPERATORS: 'Operatorius:',
    IMPORT_FROM_FILE: 'Importuoti iš failo',
    ADD_NEW_LOCATION: 'Pridėti naują vietą',
    CONTROLLER: 'Valdiklis',
    STATISTICS: 'Statistika',
    MONTHLY_PASSES: 'Mėnesiniai abonementai',
    WHITELIST: 'Leidimų sąrašas',
    EVENTS: 'Įvykiai',
    LPR: 'LPR (valstybinio numerio atpažinimas)',
    DEAL_TIMELOG: 'Sandorio laiko žurnalas',
    SETTINGS: 'Nustatymai',
    SETTINGS_DESCRIPTION: 'Visi nustatymai',
    DAY_PASSES: 'Įvažiavimo leidimai',
    BOOKING: 'Rezervacija',
    KIOSKS: 'Kioskai'
  },
  CONTROLLERS: {
    REFRESH: 'Atnaujinti',
    CONTROLLER_LOGS: 'Valdiklio žurnalai',
    FIRMWARE: 'Programinė įranga',
    FIRMWARE_UPDATE: 'Programinės įrangos atnaujinimas',
    UPDATE_FIRMWARE: 'Atnaujinti programinę įrangą',
    FIRMWARE_VERSION: 'Programinės įrangos versija',
    FIRMWARE_VERSION_INFORMATION_TITLE:
      'Informacija apie programinės įrangos versiją',
    VERSION: 'Versija',
    REASON: 'Priežastis',
    OTA_NOTIFICATION_DESCRIPTION:
      'Šiuo metu neįmanoma nuotoliniu būdu atnaujinti programinės įrangos, kuri prasideda skaičiais 1.1.',
    CLOSED: 'UŽDARYTA',
    OPENED: 'ATIDARYTA',
    ADD_CONTROLLER: 'Pridėti valdiklį',
    EDIT_CONTROLLER: 'Redaguoti valdiklį'
  },
  EDIT_PLACE: {
    SCHEDULE_VALIDITY: {
      TITLE: 'Tvarkaraščio galiojimas',
      FROM: 'Nuo',
      TO: 'Iki',
      UNLIMITED: 'Neribota'
    },
    RENTAL_SCHEDULE: {
      TITLE: 'Nuomos grafikas',
      COPY_MONDAY_SCHEDULE: 'Kopijuoti pirmadienį visiems',
      SPOTS: 'Vietos',
      OTHER_TIMES: 'Kiti laikai',
      IS_CLOSED: 'Uždaryta'
    },
    MONTHLY: {
      TITLE: 'Mėnesinės prenumeratos',
      ENABLED: 'Įjungta',
      MONTHLY_COST: 'Mėnesio kaina',
      MAX_NUM: 'Maksimalus kiekis',
      NOTIFICATION_EMAILS: 'Pranešimų el. paštai',
      DESCRIPTION_FOR_APP: 'Aprašymas programėlei',
      NO_ACTIVE_MONTHLY_PASSES: 'Nėra aktyvių mėnesinių abonementų',
      NO_EXPIRED_MONTHLY_PASSES: 'Nėra pasibaigusių mėnesinių abonementų',
      UPDATED: 'Mėnesinis abonementas sėkmingai atnaujintas',
      ADDED: 'Mėnesinis abonementas sėkmingai pridėtas'
    }
  },
  LOGIN: {
    EMAIL: 'El. paštas',
    PASSWORD: 'Slaptažodis',
    INVALID_INPUTS: 'Neteisingas el. paštas arba slaptažodis',
    FORGOT_PASSWORD: 'Pamiršote slaptažodį?',
    FORGOT_PASSWORD_TITLE: 'Pamiršote slaptažodį',
    SUBMIT: 'Pateikti'
  },
  REGISTER: {
    REGISTER: 'Registruotis',
    NAME: 'Vardas',
    EMAIL: 'El. paštas',
    PHONE_NUMBER: 'Telefono numeris',
    PASSWORD: 'Slaptažodis',
    PASSWORD_AGAIN: 'Pakartokite slaptažodį'
  },
  STATISTICS: {
    TITLE: 'Statistika',
    SHOW: 'Rodyti',
    SHOW_LOG: 'Rodyti žurnalą',
    FROM: 'Nuo',
    TO: 'Iki',
    WITH_APP: 'Su programėle',
    WITHOUT_APP: 'Be programėlės',
    TOTAL_SESSIONS: 'Visos sesijos',
    TIMESTAMP: 'Laiko žyma',
    EVENT: 'Įvykis',
    SESSIONS_PER_DAY: 'Parkavimo sesijos per dieną',
    TIME_OF_DAY: 'Dienos laikas',
    PARKING_SESSIONS: 'Parkavimo sesijos',
    GROUP_BY_CAR: 'Grupuoti pagal automobilio nr.',
    SELF_PAID_PARKING_SESSIONS: 'Savarankiškai apmokėtos parkavimo sesijos'
  },
  WHITELISTS: {
    TITLE: 'Leidimų sąrašai',
    REGION: 'Regionas',
    NAME: 'Pavadinimas',
    VALID_IN: 'Galioja',
    APPROVED_USERS: 'Patvirtinti naudotojai',
    PENDING_USERS: 'Laukiantys naudotojai',
    ADD_NEW: 'Pridėti naują',
    WITH_AVAILABILITY_INFO: 'Su prieinama informacija',
    ACTIVE_USERS: 'Aktyvūs naudotojai',
    INACTIVE_USERS: 'Neaktyvūs naudotojai'
  },
  EDIT_WHITELISTS: {
    ADD_NEW_WHITELIST: 'Pridėti naują leidimų sąrašą',
    EDIT_WHITELIST: 'Redaguoti leidimų sąrašą',
    DETAILS: 'DETALĖS',
    USERS: 'Naudotojai',
    SESSIONS: 'SESIJOS',
    NAME: 'Pavadinimas',
    APP: 'Programėlė',
    REGION: 'Regionas',
    VALID_IN: 'Galioja',
    REGISTRATION_ALLOWED_UNTIL: 'Registracija atvira iki',
    REG_CODE_FOR_APP: 'Registracijos kodas programėlėje',
    AUTO_APPROVE: 'Automatiškai patvirtinti naudotojus',
    ONE_TIME_CODES: 'Vienkartiniai reklaminiai kodai',
    REG_NOTIFICATION_EMAILS: 'Pranešimų el. paštas',
    ADD_MANAGER: 'Pridėti vadybininką',
    PUBLIC_REG_LINK: 'Vieša registracijos nuoroda',
    MANAGERS: 'Vadybininkai',
    NO_MANAGERS: 'Nėra aktyvių vadybininkų',
    CHARGE_FOR_SESSIONS: 'Mokestis už sesijas',
    START_SESSIONS_WITH_LPR: 'Pradėti sesiją su LPR',
    START_SESSIONS_WITH_LPR_DESCRIPTION:
      'Sesija prasideda automatiškai, jei įdiegta automatinio numerių atpažinimo sistema',
    AVAILABILITY_AND_PRICING: 'Prieinamumas ir kainodara',
    MANAGE_AVAILABILIY_AND_PRICING: 'Valdyti prieinamumą ir kainodarą',
    EMAIL_INFO_AFTER_APPROVAL: 'El. laiško turinys po sėkmingos registracijos',
    WHITELIST_USERS: 'Leidimų sąrašo naudotojai',
    INVITE: 'Siųsti kvietimą',
    ADD_NEW: 'Pridėti naują',
    PHONE_NUMBER: 'Telefono nr.',
    CAR_NUMBERS: 'Valstybiniai numeriai',
    USER_NAME: 'Vardas',
    EMAIL: 'El. paštas',
    REG_TYPE: 'Registracijos tipas',
    REG_TIME: 'Registracijos laikas',
    COMMENTS: 'Komentarai',
    STATUS: 'Būsena',
    ACTIVE_SESSIONS: 'Aktyvios sesijos',
    SESSION_ID: 'Sesijos ID',
    LOCATION: 'Vieta',
    CAR_NUMBER: 'Valstybinis numeris',
    START_TIME: 'Pradžios laikas',
    END_TIME: 'Pabaigos laikas',
    OVERTIME_MINUTES: 'Viršyto laiko minutės',
    OVER_ALLOWED_SPOTS_LIMIT_MINUTES:
      'Parkavimo minutės virš leistų vietų limito',
    OVER_ALLOWED_SPOTS_LIMIT_NUMBER_OF_PARKING_SESSIONS:
      'Parkavimo sesijų skaičius virš leistų vietų limito',
    REPORT: 'Ataskaita',
    TYPE: 'Ataskaitos tipas',
    SESSIONS_COUNT: 'Sesijų skaičius',
    PARKED_MINUTES: 'Parkavimo minutės',
    COST: 'Kaina',
    NO_ACTIVE_SESSIONS: 'Nėra aktyvių sesijų',
    SELECT_WHITELIST: 'Pasirinkite leidimų sąrašą',
    MAX_NUMBER_OF_VEHICLES:
      'Maksimalus naudotojų / transporto priemonių skaičius',
    DEFAULT_MAX_NUMBER_OF_VEHICLES_FOR_REGISTERED_CLIENT:
      'Numatytasis maksimalus transporto priemonių skaičius registruotam klientui',
    PLACE_REQUIRED:
      'Pasirinkus bent 1 vietą būtina, jei galiojimas yra „Vieta“',
    ZONE_REQUIRED: 'Pasirinkus bent 1 zoną būtina, jei galiojimas yra „Zona“',
    MAX_NUMBER_OF_USER_VEHICLES: 'Maksimalus transporto priemonių skaičius',
    USE_OWN_AVAILABILITY_AND_PRICING:
      'Naudoti specialią prieinamumo ir kainodaros sistemą',
    ALLOW_PARKING_WITH_NO_SPOTS: 'Leisti parkavimą be vietų',
    ADD_TO_FAVORITES: 'Pridėti į mėgstamiausius',
    REMOVE_FROM_FAVORITES: 'Pašalinti iš mėgstamiausių',
    ADDED_TO_FAVORITES: 'Leidimų sąrašas pridėtas į mėgstamiausius',
    REMOVED_FROM_FAVORITES: 'Leidimų sąrašas pašalintas iš mėgstamiausių'
  },
  AVAILABILITY_TABLE: {
    TITLE: 'Prieinamumas ir kainodara',
    SUB_TITLE: 'nan',
    '24H_COST': '24 val. kaina',
    OTHER_TIMES: 'Kitu laiku',
    NUMBER_OF_SPOTS: 'Vietų skaičius',
    HOURLY_RATE: 'Valandinis tarifas',
    MIN_COST: 'Minimali kaina',
    MAX_COST: 'Maksimali kaina'
  },
  FLEETS: {
    TITLE: 'Transporto parkai',
    ADD_NEW: 'Pridėti naują',
    REGION: 'Regionas',
    NAME: 'Pavadinimas',
    TYPE: 'Tipas',
    REG_CODE: 'Registracijos kodas',
    USERS_LIMIT: 'Leidžiamų naudotojų limitas',
    USERS: 'Naudotojai',
    REPORT: 'Ataskaitos',
    DEFAULT_MINUTES_INFORMATION:
      'Pasirinkta vieta turi numatytą parkavimo minučių limitą:'
  },
  EDIT_FLEETS: {
    TITLE: 'Transporto parkai',
    NAME: 'Pavadinimas',
    TYPE: 'Tipas',
    REGION: 'Regionas',
    VALID_IN: 'Galioja',
    APP: 'Programėlė',
    DEF_DAILY_LIMIT: 'Numatytasis dienos limitas',
    DEF_MONTHLY_LIMIT: 'Numatytasis mėnesio limitas',
    MAX_NUMBER_OF_USERS: 'Maksimalus naudotojų limitas',
    RESET_LIMITS: 'Limitą atstatyti mėnesio pradžioje',
    REG_OPEN_TIL: 'Registracija atvira iki',
    REG_CODE_APP: 'Aktyvavimo kodas programėlėje',
    AUTO_APPROVE: 'Automatiškai patvirtinti naudotojus',
    ONE_TIME_PROMO_CODES: 'Vienkartiniai reklaminiai kodai programėlei',
    REG_NOTIFICATION_EMAIL: 'Pranešimų el. paštas',
    PUBLIC_REG_LINK: 'Vieša registracijos nuoroda',
    START_WITH_LPR: 'Pradėti sesiją su LPR',
    ADD_MANAGER: 'Pridėti vadybininką',
    MANAGERS: 'Vadybininkai',
    NO_MANAGERS: 'Nėra vadybininkų',
    EMAIL_BODY_AFTER_REGISTRATION:
      'El. laiško turinys po sėkmingos registracijos',
    DESC_FOR_APP: 'Aprašymas programėlei',
    PHONE_NUMBER: 'Telefono numeris',
    CAR_NUMBER: 'Valstybinis numeris',
    USER_NAME: 'Vardas',
    EMAIL: 'El. paštas',
    DAILY_LIMIT: 'Dienos limitas',
    MONTHLY_LIMIT: 'Mėnesio limitas',
    REG_TYPE: 'Registracijos tipas',
    REG_TIME: 'Registracijos laikas',
    STATUS: 'Būsena',
    INVITE: 'Siųsti kvietimą',
    ADD_NEW: 'Pridėti naują',
    FLEET_USERS: 'Naudotojai',
    SELECT_FLEET: 'Pasirinkti transporto parką',
    ADD_NEW_FLEET: 'Pridėti naują transporto parką',
    EDIT_FLEET: 'Redaguoti transporto parką',
    PLACE_REQUIRED:
      'Būtina pasirinkti bent vieną vietą, jei pasirinktas tipas „Vieta“.',
    ZONE_REQUIRED:
      'Būtina pasirinkti bent vieną zoną, jei pasirinktas tipas „Zona“.'
  },
  FLEET_REPORT: {
    LIMIT: 'Mėnesio limitas:',
    USED_TOTAL: 'Panaudota:',
    DAILY_LIMIT: 'Dienos limitas',
    MONTHLY_LIMIT: 'Mėnesio limitas',
    USED_FLEET_CREDIT: 'Panaudotas kreditas',
    AVAILABLE_FLEET_CREDIT: 'Laisvas kreditas',
    OVER_LIMIT: 'Viršytas limitas',
    SELF_PAID: 'Savarankiškai apmokėta'
  },
  REPORTS: {
    TITLE: 'Ataskaitos',
    DESCRIPTION: 'Visos ataskaitos',
    REPORT_TYPE: 'Ataskaitos tipas',
    GROUP_BY: 'Grupuoti pagal'
  },
  ADD_SESSION: {
    TITLE: 'Pridėti sesiją',
    HOURS: 'Valandos',
    DAYS: 'Dienos',
    MINUTES: 'Minutės'
  },
  ENFORCEMENT: {
    ENFORCER: 'Kontrolierius',
    ENFORCEMENT: 'Kontrolė',
    REASON: 'Priežastis',
    ADDITIONAL_REASON_CODE: 'Papildoma priežastis (kodas)',
    ADDITIONAL_REASON_TEXT: 'Papildoma priežastis (tekstas)',
    CREATED_AT: 'Išrašymo laikas',
    LOOK_IMAGES: 'Peržiūrėti nuotraukas',
    MARK_AS_PAID: 'Pažymėti baudą kaip apmokėtą',
    CANCEL_FINE: 'Atšaukti baudą',
    FINE_PAYMENT_DATE: 'Mokėjimo gavimo data',
    NO_IMAGES_TO_SHOW: 'Nėra nuotraukų (nuotraukos nebuvo padarytos)',
    PAID_AMOUNT: 'Sumokėta suma',
    OVERDUE: 'Vėluojama',
    EDIT_PARKING_FINE: 'Redaguoti parkavimo baudą',
    VEHICLE_NUMBER_COUNTRY: 'Registracijos šalis',
    LOCATION: 'Vieta',
    ISSUER_NAME: 'Kontrolierius',
    PARKING_FINES: 'Parkavimo baudos',
    PAYMENT_DATE_REQUIRED: 'Mokėjimo data yra privaloma',
    PAID_AMOUNT_REQUIRED: 'Sumokėta suma yra privaloma',
    DEBTS_SENT: 'Skolos išsiųstos',
    DEBTS_SENT_YES: 'TAIP',
    DEBTS_SENT_NO: 'NE',
    DEBT_INCOMES: 'Pajamos',
    AMOUNT_RECEIVED: 'Gauta suma',
    RECEIVED_INCOME_DATE: 'Pajamų gavimo data',
    MARK_RECEIVED_INCOME: 'Pažymėti pajamas',
    INCOMES: 'Pajamos',
    DOWNLOAD_PARKING_FINE_PDF: 'Atsisiųsti PDF',
    ID: 'ID',
    VOID_TIME: 'Anuliavimo laikas',
    PARKING_FINE: 'Parkavimo bauda',
    ALSO_CREATE_NEW_FINE: 'Taip pat sukurti naują parkavimo baudą',
    LAST_AMOUNT: 'Paskutinė kaina',
    PARKING_FINE_INVOICES: 'Sąskaitos faktūros',
    PARKING_FINE_INVOICE_NUMBER: 'Numeris',
    PARKING_FINE_INVOICE_DATE: 'Data',
    PARKING_FINE_AMOUNT: 'Suma',
    COMMENTS: 'Komentarai',
    COMMENT: 'Komentaras',
    NO_COMMENTS: 'Nėra komentarų...',
    REFERENCE_NUMBER: 'Nuorodos numeris',
    PARKING_FINE_PROFILE_BENEFICIARY: 'Gavėjas',
    SEND_FINE_TO_JULIANUS: 'Perduoti Julianus',
    RESET_PARKING_FINE: 'Atstatyti parkavimo baudą',
    DO_NOT_FORWARD_DEBTS: 'Neperduoti skolų',
    HAS_SENT_APPEAL: 'Pateiktas skundas',
    PARKING_FINE_UPDATED_SUCCESSFULLY: 'Parkavimo bauda sėkmingai atnaujinta',
    DEBTS_WILL_BE_FORWARDED_AT: 'Skolų perdavimo terminas pratęstas iki:',
    PARKING_STATUS_CHECK_LOGS: 'Valstybinių numerių patikros',
    CHECKED_AT: 'Tikrinta',
    HAD_PARKING: 'Parkavimas',
    INCOME_RECEIVED_VIA_CHANNEL: 'Kanalas',
    INCOME_INSERTER: 'Įvedėjas',
    INCOME_RECEIVED_AT: 'Gauta suma',
    FORWARD_DEBTS_AT: 'Skolų perdavimo data',
    COMMENTS_REQUIRED: 'Komentaras yra privalomas',
    PARKING_FINE_REPORTS: {
      TITLE: 'Automatizuotos ataskaitos',
      EDIT: 'Redaguoti',
      ADD_NEW: 'Pridėti naują',
      EMAIL_TO: 'El. pašto gavėjai',
      EMAIL_BCC: 'El. pašto BCC gavėjai',
      SENDING_DAYS: 'Dienos, kada generuoti / siųsti',
      IS_MONTHLY_REPORTING_ENABLED: 'Ataskaitų siuntimas įjungtas',
      NEW_VEHICLE_GROUP_NAME: 'Naujas grupės pavadinimas',
      NEW_VEHICLE_GROUP_NAME_IS_REQUIRED:
        'Naujas transporto priemonių grupės pavadinimas yra privalomas',
      VEHICLE_LIST: 'Transporto priemonių sąrašas',
      NEW_TASK_ADDED_SUCCESSFULLY: 'Nauja ataskaitų užduotis sėkmingai sukurta'
    },
    ENFORCEMENT_OFFICERS: {
      TITLE: 'Kontrolieriai',
      ADD_NEW_OFFICER: 'Pridėti naują kontrolierių',
      EDIT_OFFICER: 'Redaguoti kontrolieriaus informaciją',
      EMAIL: 'El. paštas',
      PASSWORD: 'Slaptažodis',
      OFFICER_NAME: 'Vardas',
      GROUP: 'Grupė'
    },
    PARKING_FINE_PLATFORM_URL: 'Parkavimo baudų platformos nuoroda',
    PENALTY_APPEAL_COMMENTS: 'Baudos apskundimo komentarai',
    PENALTY_APPEAL_COMMENTS_ADD: 'Pridėti baudos apskundimo komentarus',
    COMMENTS_TOO_LONG: 'Komentarai negali būti ilgesni nei 1024 simboliai',
    REGION: 'Regionas'
  },
  SETTINGS: {
    OPERATOR_SETTINGS: 'Operatoriaus nustatymai',
    OPERATOR_SETTINGS_DESCRIPTION: 'Visi operatoriaus nustatymai',
    ADD_NEW_ZONE: 'Pridėti naują zoną',
    NO_ZONES: 'Nėra zonų',
    CHOOSE_ICON: 'Pasirinkite ikoną',
    ZONE_UPDATED: 'Zona sėkmingai atnaujinta!',
    NEW_ZONE_ADDED: 'Nauja zona sėkmingai pridėta!',
    EDIT_ZONE: 'Redaguoti zoną'
  },
  ENTER_PASSWORD: 'Įveskite slaptažodį',
  REPEAT_PASSWORD: 'Pakartokite slaptažodį',
  ACTIVATE_ACCOUT: 'Aktyvuokite savo paskyrą',
  PASSWORD_CRITERIA_MISMATCH:
    'Slaptažodis turi turėti bent 8 simbolius, 1 skaičių ir 1 didžiąją raidę',
  ACCOUNT_ACTIVATED_SUCCESSFULLY:
    'Paskyra aktyvuota! Naudokite naują slaptažodį prisijungimui',
  AUTO_GENERATE_PASSWORD: 'Generuoti slaptažodį automatiškai',
  PROFILE: 'Profilis',
  SEND_OWNER_INVITE: 'Siųsti kvietimą',
  UPDATE_PASSWORD: 'Atnaujinti slaptažodį',
  SEARCH_BY_VEHICLE: 'Ieškoti pagal transporto priemonės numerį',
  BOOKING: {
    CAR_NUMBER: 'Automobilis',
    START_TIME: 'Pradžios laikas',
    END_TIME: 'Pabaigos laikas',
    NAME: 'Vardas',
    PHONE_NUMBER: 'Telefonas',
    EMAIL: 'El. paštas',
    COMMENTS: 'Komentaras',
    SEARCH_TITLE: 'Rezervacijų paieška',
    CLIENT: 'Klientas',
    EDIT_BOOKING: 'Redaguoti rezervaciją',
    DELETE_BOOKING: 'Ištrinti rezervaciją',
    ADD_NEW: 'Pridėti naują rezervaciją',
    STATUS: 'Būsena',
    EXTERNAL_BOOKING_NUMBER: 'Išorinis rezervacijos numeris',
    DATE_PLACEHOLDER: '2099-12-31 00:00:00',
    TIME_PLACEHOLDER: '23:59:00',
    START_DATE: 'Pradžios data',
    END_DATE: 'Pabaigos data',
    PARKING_STATUS_PARKING: 'Parkuoja',
    PARKING_STATUS_NOT_PARKING: 'Neparkuoja',
    CAR_IS_REQUIRED: 'Automobilis yra privalomas',
    TIME_FORMAT_INCORRECT: 'Laiko formatas turi būti HH:MM',
    DATE_FORMAT_INCORRECT: 'Datos formatas turi būti 31.01.2024',
    END_BOOKING: 'Užbaigti rezervaciją',
    END_BOOKING_DESCRIPTION: 'Ar tikrai norite užbaigti šią rezervaciją?',
    PUT_SUCCESSFUL: 'Rezervacija sėkmingai atnaujinta',
    ADD_BOOKING: 'Pridėti rezervaciją',
    POST_SUCCESSFUL: 'Rezervacija sėkmingai sukurta',
    PARKING_ACTIVE: 'Parkavimas aktyvus',
    PARKING_NOT_ACTIVE: 'Parkavimas neaktyvus',
    STARTING_BOOKINGS: 'Pradedamos rezervacijos',
    OCCUPANCY_CALENDAR: 'Užimtumo kalendorius',
    ACTIVE_PARKINGS_CURRENTLY: 'Šiuo metu aktyvūs parkavimai',
    COST: 'Kaina',
    CREATED_AT: 'Sukurta'
  },
  QUICK_ACTIONS: {
    TOOLTIP: 'Greitieji veiksmai',
    COMMAND_SENT: 'Komanda išsiųsta',
    COMMAND_FAILED: 'Komandos siuntimas nepavyko'
  },
  EDIT_SESSION: 'Redaguoti sesiją',
  DELETE_SESSION: 'Ištrinti sesiją',
  SET_CURRENT_END_TIMESTAMP: 'Nustatyti pabaigos laiką į dabar',
  AUTOMATIC_PAY_AFTER_SAVE: 'Automatiškai apskaičiuoti kainą',
  MAKE_PAYMENT_AFTER_SAVE: 'Pradėti mokėjimą po išsaugojimo',
  SESSION_WITH_BOOKING: 'Sesija su rezervacija',
  SEARCH_BY_NAME_OR_EMAIL: 'Ieškoti pagal vardą arba el. paštą',
  VEHICLE_GROUPS: {
    TITLE: 'Transporto priemonių grupės',
    GROUP_NAME: 'Grupės pavadinimas',
    ADD_NEW: 'Pridėti naują',
    EDIT: 'Redaguoti',
    PUT_SUCCESSFUL: 'Sėkmingai pakeista',
    POST_SUCCESSFUL: 'Sėkmingai pridėta',
    LICENSE_PLATES: 'Valstybiniai numeriai',
    LICENSE_PLATE: 'Valstybinis numeris',
    LICENSE_PLATES_POST_SUCCESSFUL: 'Sąrašas sėkmingai atnaujintas',
    LICENSE_PLATE_IMPORT_WARNING_MESSAGE:
      'Jūs ruošiatės importuoti šiuos valstybinius numerius:',
    DELETE_SUCCESSFUL: 'Sėkmingai ištrinta',
    LICENSE_PLATE_DELETE_WARNING_MESSAGE:
      'Jūs ruošiatės ištrinti valstybinį numerį:',
    ENTER_NEW_LICENSE_PLATE:
      'Įveskite naują automobilio valstybinį numerį formatu 123ABC',
    REMOVE_EXISTING_VEHICLES: 'Pašalinti esamas transporto priemones'
  },
  ADD_NEW: 'Pridėti naują',
  CAR_WASH_DISPUTES: {
    TITLE: 'Ginčai',
    CREATED_AT: 'Sukurta',
    LICENSE_PLATE: 'Valstybinis numeris',
    STATUS: 'Būsena',
    EDIT_DISPUTE: 'Redaguoti',
    SERVICE_TIME: 'Paslaugos laikas',
    EDIT: 'Redaguoti ginčą',
    AMOUNT: 'Suma',
    MESSAGE: 'Žinutė',
    REJECT: 'Atmesti',
    APPROVE: 'Patvirtinti',
    ALL_DISPUTES: 'Visi ginčai',
    PLACE_NAME: 'Vietos pavadinimas',
    SERVICE_NAME: 'Paslaugos pavadinimas'
  },
  SEARCH_BY_PLACE_FLEET_OR_WHITELIST_NAME:
    'Vietos, parko arba leidimų sąrašo pavadinimas',
  PRICE: 'Kaina',
  FROM_PREVIOUS_MONTH_START: 'Nuo praėjusio mėnesio pradžios',
  PREVIOUS_MONTH: 'Praėjęs mėnuo',
  CURRENT_MONTH: 'Šis mėnuo',
  PREVIOUS_WEEK: 'Praėjusi savaitė',
  CURRENT_WEEK: 'Ši savaitė',
  YESTERDAY: 'Vakar',
  TODAY: 'Šiandien',
  LAST_7_DAYS: 'Paskutinės 7 dienos',
  PARKED_MINUTES: 'Parkavimo minutės',
  OVERTIME_MINUTES: 'Viršytas laikas minutėmis',
  GATE_CONTROLLERS: {
    ADD_NEW: 'Pridėti naują',
    ACTIONS: 'Veiksmai',
    RESTART: 'Paleisti iš naujo',
    PIN_STATES: 'Pin būsenos',
    OUTPUT_PIN_STATES: 'Išėjimo pin būsenos',
    LAST_HEARTBEAT: 'Paskutinis signalas',
    SIGNAL_STRENGTH: 'Signalo stiprumas',
    OPEN: 'Atidaryti'
  }
}
